import {
  ProjectStatusType,
  QuotationPartnerRfqCurrentSituationType
} from '@generated/graphql';
import { CustomizedLabel } from '@components/Customized';
import { FunctionComponent } from 'react';
import { ReactNode } from 'react';

const PositiveLabel: FunctionComponent<{ children: ReactNode }> = ({
  children
}) => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="primary200"
      textColor="primary500"
    >
      {children}
    </CustomizedLabel>
  );
};

const NegativeLabel: FunctionComponent<{ children: ReactNode }> = ({
  children
}) => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="errorLight"
      textColor="errorMain"
    >
      {children}
    </CustomizedLabel>
  );
};

const RequestCloseLabel = () => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="gray000"
      borderColor="gray400"
      textColor="gray700"
    >
      견적비교 마감
    </CustomizedLabel>
  );
};

const SentIntroduction = () => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="warningLight"
      textColor="warningDark"
    >
      회사소개서 보냄
    </CustomizedLabel>
  );
};

const ConsultingWithMe = () => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="primary200"
      textColor="primary500"
    >
      나와 상담중
    </CustomizedLabel>
  );
};

const ConsultingWithOther = () => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="gray400"
      textColor="gray900"
    >
      타업체 상담중
    </CustomizedLabel>
  );
};

const OrderdToOther = () => {
  return (
    <CustomizedLabel
      variant="round"
      backgroundColor="gray400"
      textColor="gray900"
    >
      타업체 발주
    </CustomizedLabel>
  );
};

const ProjectStatusLabel = ({
  status
}: {
  status?: ProjectStatusType | null;
}) => {
  switch (status) {
    case ProjectStatusType.QuotationComparison: {
      return (
        <CustomizedLabel backgroundColor="gray900" textColor="gray000">
          견적비교중
        </CustomizedLabel>
      );
    }

    case ProjectStatusType.QuotationComparisonClosing: {
      return <RequestCloseLabel />;
    }

    case ProjectStatusType.OrderInprogress: {
      return <PositiveLabel>결제/발주중</PositiveLabel>;
    }

    case ProjectStatusType.OrderSuspended: {
      return <NegativeLabel>결제/발주중단</NegativeLabel>;
    }

    case ProjectStatusType.Processing: {
      return <PositiveLabel>제조중</PositiveLabel>;
    }

    case ProjectStatusType.ProcessInterruption: {
      return <NegativeLabel>제조중단</NegativeLabel>;
    }

    case ProjectStatusType.Shipping: {
      return <PositiveLabel>배송중</PositiveLabel>;
    }

    case ProjectStatusType.ConfirmPurchaseOrder: {
      return (
        <CustomizedLabel variant="round" color="heavyPrimary">
          거래완료
        </CustomizedLabel>
      );
    }

    default:
      return null;
  }
};

const RfqStatusLabel: FunctionComponent<{
  currentStatus?: QuotationPartnerRfqCurrentSituationType;
}> = ({ currentStatus }) => {
  switch (currentStatus) {
    case QuotationPartnerRfqCurrentSituationType.RequestFinish:
      return <RequestCloseLabel />;
    case QuotationPartnerRfqCurrentSituationType.SendQuotation:
      return <PositiveLabel>견적서 보냄</PositiveLabel>;
    case QuotationPartnerRfqCurrentSituationType.ConsultingWithMe:
      return <ConsultingWithMe />;
    case QuotationPartnerRfqCurrentSituationType.OtherCompanyOrder:
      return <OrderdToOther />;
    case QuotationPartnerRfqCurrentSituationType.ConsultingWithOtherCompany:
      return <ConsultingWithOther />;
    case QuotationPartnerRfqCurrentSituationType.SendCompanyIntroduction:
      return <SentIntroduction />;
    case QuotationPartnerRfqCurrentSituationType.OrderInprogress:
      return <PositiveLabel>결제/발주중</PositiveLabel>;
    case QuotationPartnerRfqCurrentSituationType.OrderSuspended:
      return <NegativeLabel>결제/발주중단</NegativeLabel>;
    case QuotationPartnerRfqCurrentSituationType.Processing:
      return <PositiveLabel>제조중</PositiveLabel>;
    case QuotationPartnerRfqCurrentSituationType.ProcessInterruption:
      return <NegativeLabel>제조중단</NegativeLabel>;
    case QuotationPartnerRfqCurrentSituationType.Shipping:
      return <PositiveLabel>배송중</PositiveLabel>;
    case QuotationPartnerRfqCurrentSituationType.ConfirmPurchaseOrder:
      return (
        <CustomizedLabel variant="round" color="heavyPrimary">
          거래완료
        </CustomizedLabel>
      );
    default:
      return null;
  }
};

export { RfqStatusLabel, ProjectStatusLabel };
